import filterSelect from './filterSelect';
import filterDatePicker from './filterDatePicker';

export default {
  init() {
    filterSelect();
    filterDatePicker();
    this.events();

    this.handleClearVisibility();
  },

  events() {
    $('.post-filters-list__open').on('click', () => {
      $('.post-filters-list').addClass('post-filters-list--open');
      $('body').addClass('fade-out');
    });
    $('.post-filters-list__close').on('click', () => {
      $('.post-filters-list').removeClass('post-filters-list--open');
      $('body').removeClass('fade-out');
    });

    // On input change.
    $('.filter-select__input').on('change', () => {
      this.handleClearVisibility();
      if (
        $('.post-filters-list').hasClass('post-filters-list--open') &&
        $(window).outerWidth() < 600
      ) {
        $('body').removeClass('fade-out');
        $('.post-filters-list').removeClass('post-filters-list--open');
        $('.filter-select__options').slideUp();
      }
    });

    // On clear click
    $('.post-filters-list__clear').on('click', () => {
      $('.post-filters-list__clear').removeClass(
        'post-filters-list__clear--visible'
      );
      if ($('.post-filters-list').hasClass('post-filters-list--open')) {
        $('.post-filters-list').removeClass('post-filters-list--open');
        $('body').removeClass('fade-out');
      }
      this.handleClearList();
    });
  },

  handleClearVisibility() {
    let filled = [];
    $('.post-filters-list .filter-select__input').each((_i, inputEl) => {
      if (!$(inputEl).val()) {
        return;
      }

      filled.push($(inputEl).val());
    });

    const clearEl = $('.post-filters-list .post-filters-list__clear');
    if (filled.length) {
      clearEl.addClass('post-filters-list__clear--visible');
    } else {
      clearEl.removeClass('post-filters-list__clear--visible');
    }
  },

  handleClearList() {
    $('.post-filters-list .filter-select').each((_i, selectEl) => {
      selectEl = $(selectEl);
      selectEl.children('.filter-select__input').val('').trigger('change');
      selectEl.removeClass('filter-select--filtered');
      // Reset text
      const selectLabelEl = selectEl.children('.filter-select__main');
      selectLabelEl.find('span').text(selectLabelEl.data('label'));
    });

    $('.post-filter-tag').removeClass('active');
  },
};
